export default "__VITE_ASSET__Bsp9UDBx__"